import React from 'react';

function B2Cservice(props) {
    const { title } = props
    return (
        <>
            <div className=" py-3 mt-4">
                <div className={`d-flex ${window.innerWidth < 750 && "flex-column"} align-items-center`}>
                    <div >
                        <h5 className="pt-4 pb-3 white-2 ">{title}</h5>
                        <h3 className='pb-2'>Lorem ipsum dolor Lorem ipsum dolor  rem, sapiente ipsam tenetur. Cumque, dolores!</h3>
                        <ul>
                            <li>Lorem ipsum</li>
                            <li>sit amet</li>
                            <li>dolor consectetur</li>
                            <li>adipisicing elit</li>
                        </ul>
                <a href="" className="btn btn-deep-orange white-text letter-dis-1 py-2 px-3 align-content-center">learn about our solutions</a>
                    </div>
                    <img className='pt-5' style={{ width: "clamp(250px,40%,400px)", aspectRatio: "1",borderRadius: "8px"}} src={require('../resource/demo.webp')} alt="" />
                </div>
            </div>

        </>
    )
}

export default B2Cservice;
